import React, {Component} from "react";
import {
  Button,
  CircularProgress,
  Divider,
  Fab,
  Grid,
  Hidden,
  Icon,
  Typography
} from "@material-ui/core";
import {connect} from "react-redux";
import Header from "../../components/Header";
import {
  parentContainer,
  primaryColor,
  textBlack,
  textGrey,
  webFont
} from "../../config/theme";
import PublicDishesView from "./PublicProfileDishes";
import SinglePost from "../../components/Posts/SinglePost";
import {client} from "../../config/apollo";

import {GET_CHEF_BY_USERNAME} from "../../graphql/queries/chef";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import {Helmet} from "react-helmet";

const defaultChefImg = "/images/simple-chef.webp";
const tick = "/images/tick.webp";

class ChefDiner extends Component {
  state = {
    chef: {},
    reviews: [],
    viewAsDiner: true,
  };

  componentDidMount() {
    if (this.props.match) {
      if (this.props.match.params) {
        if (this.props.match.params.slug) {
          const slug = this.props.match.params.slug;
          client
            .query({
              query: GET_CHEF_BY_USERNAME,
              variables: {
                username: slug
              },
              fetchPolicy: "network-only"
            })
            .then(response => {
              this.setState({ chef: response.data.chefByUsername });
            })
            .catch(err => {
              console.error('ERR Fetching public chef profile');
              this.props.history.push("/");
            });
        } else {
          this.props.history.push("/");
        }
      } else {
        this.props.history.push("/");
      }
    } else {
      this.props.history.push("/");
    }
  }

  createMarkup = (text) => {
    return {__html: text};
  };

  handleClickPost = (postSlug)  => {
    if (postSlug) this.props.history.push(`/home/post/${postSlug}`);
  };

  redirectToSignIn = () => {
    this.props.history.push('/sign-in');
  }

  renderVideo = item => {
    return (
      <iframe
        src={item.embedUrl}
        width="212"
        height="212"
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen></iframe>);
  };

  renderImgItem = item => {
    return (
      <Grid item>
        <Hidden only={["xs", "lg", "xl"]}>
          <img
            data-test-id={"chefimg-id"}
            src={item.original}
            style={{...styles.chefImg, ...styles.chefImgIPad}}
          />
        </Hidden>
        <Hidden only={["sm", "md"]}>
          <img
            data-test-id={"chefimg-id"}
            src={item.original}
            style={{...styles.chefImg, ...styles.chefImgLg}}
          />
        </Hidden>
      </Grid>
    );
  };

  render() {
    const {history} = this.props;
    const {chef} = this.state;

    const imgItems = [];

    if (!!chef.media) {
      if (chef.media.length > 0) {
        chef.media.forEach(mItem => {
          if (mItem.size && mItem.type) {
            if  (mItem.type === 'PHOTO' && mItem.size !== 'SMALL_SQUARE_THUMBNAIL') {
              imgItems.push({
                original: mItem.url,
                originalAlt: chef.firstName,
                renderItem: this.renderImgItem
              });
            }
          }
        });
      } else {
        imgItems.push({
          original: defaultChefImg,
          renderItem: this.renderImgItem,
          originalAlt: chef.firstName,
        });
      }
    }

    if (chef.vimeoId && !!chef.s3) {
      if (chef.s3.processed) {
        imgItems.push({
          original: defaultChefImg,
          embedUrl: `https://player.vimeo.com/video/${chef.vimeoId}`,
          renderItem: this.renderVideo,
          originalAlt: chef.firstName,
        });
      }
    }

    let chefCuisines = "";
    if (chef.cuisines) {
      chef.cuisines.forEach(cuisine => {
        chefCuisines += cuisine + ", ";
      });
    }

    chefCuisines = chefCuisines.substr(0, chefCuisines.trim().length - 1);

    /*if (chef.cuisines.length > 3) {
      chefCuisines = "Multi Cuisines";
    }*/

    let chefRatings = 0;

    if (chef.rating) {
      if (chef.rating > 0) {
        chefRatings = Math.floor(chef.rating);
      }
    }

    const story = chef.story ? chef.story.replace(/\n/g, "<br />") : "<br />";

    let ratingStars = null;

    if (chefRatings > 0) {
      switch (chefRatings) {
        case 1:
          ratingStars = <Icon className="star-icon">star_rate</Icon>;
          break;

        case 2:
          ratingStars = (
            <div>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
            </div>
          );
          break;

        case 3:
          ratingStars = (
            <div>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
            </div>
          );
          break;

        case 4:
          ratingStars = (
            <div>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
            </div>
          );
          break;

        case 5:
          ratingStars = (
            <div>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
            </div>
          );
          break;
      }
    } else {
      chefRatings = "";
    }


    /*const dishesList2 = (
      <DishesList
        type="dishesByChef"
        pageSize={50}
        filters={{chefId: chef.id}}
        next={null}
        isLiveShow={false}
        previous={null}
        {...this.props}
        viewAsDiner={true}
        updatedAt={null}
      />
    );*/

    const dishesList2 = (
      <PublicDishesView
        dishesList={chef.dishesList ? chef.dishesList.dishes : []}
        handleClick={this.redirectToSignIn}
      />
    );

    let postsList = <></>;
    if (chef.postsList) {
      if (chef.postsList.posts) {
        postsList = chef.postsList.posts.length ? chef.postsList.posts.map((post, index) => {
          return (
            <Grid key={index.toString()} className="featured-post-item">
              <SinglePost
                key={index.toString()}
                post={post}
                index={index}
                page={"profile"}
                handleClick={() => this.handleClickPost(post.postSlug)}
                viewAsDiner={this.state.viewAsDiner}
              />
            </Grid>
          );
        }) : (
          <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
            No posts added yet.
          </div>
        );
      }
    }

    return (
      <div style={{...parentContainer, position: "relative"}}>
        <Grid container>
          <Grid item xs={12}>
            <Header history={history}/>
            <Helmet>
              <meta name="description" content={chef && chef.story ? chef.story : 'Cuisine Crafters Chef'} />
              <link rel="canonical" href={`https://cuisinecrafters.net/chef/profile/${chef ? chef.username : ''}`} />
            </Helmet>
          </Grid>
        </Grid>

        <div className="profile-diner-container">
          <Grid item className="chef-detail-row" direction={'column'} lg={12} xs={12} xl={12} sm={12}>
            <Grid className="chef-detail-container" container direction={'row'} lg={12} xs={12} xl={12} sm={12} justify={'space-between'}>
              <Grid className="chef-detailcol-left" item>
                <Grid container>
                  {imgItems.length > 0 ? (<ImageGallery
                    autoPlay={false}
                    items={imgItems}
                    lazyLoad={true}
                    infinte={true}
                    showBullets={true}
                    showFullscreenButton={false}
                    showNav={false}
                    showPlayButton={false}
                    showThumbnails={false}
                    showIndex={false}
                    slideDuration={450}
                    slideInterval={3500}
                  />) : (
                    <Grid item>
                      <Hidden only={["xs", "lg", "xl"]}>
                        <img
                          data-test-id={"chefimg-id"}
                          src={defaultChefImg}
                          style={{...styles.chefImg, ...styles.chefImgIPad}}
                        />
                      </Hidden>
                      <Hidden only={["sm", "md"]}>
                        <img
                          data-test-id={"chefimg-id"}
                          src={defaultChefImg}
                          style={{...styles.chefImg, ...styles.chefImgLg}}
                        />
                      </Hidden>
                    </Grid>
                  )}

                  <Grid data-test-id={"chefdet-id"} item direction={'column'} style={{display: 'flex', flex: 'auto', marginTop: 20, paddingLeft: 32}}>

                    <Typography
                      variant="h4"
                      style={{...styles.setFont, marginTop: 25, marginRight: 10, fontSize: 32, fontWeight: 500, position: 'relative'}}
                    >
                      {chef.firstName} {chef.lastName}
                      {chef.verified && <div style={{ position: 'absolute', top: -5, left: -25 }}>
                        <img src={tick} alt="Verified Chef" style={styles.tick} />
                      </div>}
                    </Typography>

                    <Typography
                      variant="subheading"
                      style={{margin: '6px 0 7px', color: '#7c7c7c', fontSize: 22, opacity: '0.8', fontWeight: 500 }}
                    >
                      {chefCuisines}
                    </Typography>
                    <Grid data-test-id={"chefrtngs-id"} container style={{marginTop: 10}}>
                      <Typography
                        style={{
                          ...styles.setFont,
                          ...styles.setFontPrimary
                        }}
                      >
                        {chef.rating && chef.rating > 0 && ratingStars}
                      </Typography>
                      <Typography
                        style={{
                          ...styles.setFont,
                          ...styles.setFontPrimary,
                          marginLeft: chef.rating && chef.rating > 0 ? 7 : 0,
                        }}
                      >
                        {chefRatings}
                      </Typography>

                      <Typography
                        align={"center"}
                        style={{...styles.setFont,...{marginLeft: chef.rating && chef.rating > 0 ? 10 : 0, color: chef.reviewCount ? '#7c7c7c' : '#ff8000'}}}
                      >
                        {chef.reviewCount ? `${chef.reviewCount} Reviews` : 'No ratings'}
                      </Typography>
                    </Grid>

                  </Grid>
                </Grid>
              </Grid>


              <Grid item className="diner-book-now">
                <Button
                  className="diner-book-btn"
                  data-test-id={"chefbooknow"}
                  onClick={this.redirectToSignIn}
                >
                  Book now
                </Button>
              </Grid>

            </Grid>


            <Divider variant={"fullWidth"} style={{margin: '40px 0'}}/>

            <Grid data-test-id={"about-id"} item style={styles.ftGrid}>
              <Grid container alignItems="flex-start">
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }} />
                <Grid item xs={6} md={4} lg={4} xl={2} >
                  <Typography variant="h5" style={{...styles.ftText, textAlign: 'center' }} align={"center"}>
                    About
                  </Typography>
                </Grid>
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }}  />
              </Grid>
              <div style={{ maxWidth: 600, textAlign: story.length > 200 ? 'justify' : 'center', margin: '0px auto' }}>
                <Typography
                  style={{
                    ...styles.ftGrid,
                    fontSize: 18,
                    color: "#000",
                    opacity: 0.7,
                    wordBreak: 'break-word',
                    ...styles.setFont
                  }}
                >
                  <div dangerouslySetInnerHTML={this.createMarkup(story)} />
                </Typography>

                <div style={{ textAlign: 'left', fontSize: 14 }}>
                  <p>
                    <strong>Cancelation Policy: </strong>
                    {chef.firstName} {chef.lastName} {chef.cancellationPolicy && chef.cancellationPolicy.allowCancellation ? ' allows ' : ' disallows '} cancelation of confirmed engagements
                    {chef.cancellationPolicy && chef.cancellationPolicy.allowCancellation && chef.cancellationPolicy.penaltyCharge == 0 && ' without a fee.'}
                    {chef.cancellationPolicy && chef.cancellationPolicy.allowCancellation && chef.cancellationPolicy.penaltyCharge != 0 ? <>
                      {' '}under the following terms.
                      <ul>
                        <li style={{ textAlign: 'left' }}>No cancelation charges if canceled {chef.cancellationPolicy.timeBeforeCancellation} {chef.cancellationPolicy.timeBeforeCancellationMetric} before engagement time</li>
                        <li style={{ textAlign: 'left' }}>Any cancelations within {chef.cancellationPolicy.timeBeforeCancellation} {chef.cancellationPolicy.timeBeforeCancellationMetric} of engagement time, will result in cancelation charge of {chef.cancellationPolicy.penaltyCharge}% of booking amount.</li>
                        {chef.cancellationPolicy.allowCancellation && chef.cancellationPolicy.comments && <li style={{ textAlign: 'left' }}>
                          {chef.cancellationPolicy && chef.cancellationPolicy.comments ? <>
                            {chef.cancellationPolicy.comments.toString().charAt(0).toUpperCase() + chef.cancellationPolicy.comments.slice(1)}
                          </> : <></>}
                        </li>}
                      </ul>
                    </> : <span></span>}
                  </p>
                </div>
              </div>
            </Grid>

            <Grid container direction="column" style={{...styles.ftGrid}}>
              <Grid container alignItems="flex-start">
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }} />
                <Grid item xs={6} md={4} lg={4} xl={2} >
                  <Typography variant="h5" style={{fontFamily: webFont,
                    color: textBlack,
                    fontWeight: 500,
                    marginBottom: 30,
                    marginTop: 30,
                    fontSize: 30,
                    textAlign: 'center'}} align={"center"}>
                    Dishes
                  </Typography>
                </Grid>
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }}  />
              </Grid>
              <div className="profile-dish-col">
                {dishesList2}
              </div>
            </Grid>

            <Grid container style={{...styles.ftGrid, textAlign: 'center'}}>
              <Grid container alignItems="flex-start">
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }} />
                <Grid item xs={6} md={4} lg={4} xl={2} >
                  <Typography variant="h5" style={styles.ftText} align={"center"}>
                    Posts
                  </Typography>
                </Grid>
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }}  />
              </Grid>
            </Grid>

            <Grid container style={{...styles.ftGrid}} spacing={32}>
              <div className="profile-post-col">
                {postsList}
              </div>
            </Grid>

            {this.state.selectedDishCount > 0 && (
              <Fab
                data-test-id={"selectdish-id"}
                style={{...styles.bookingFab}}
                color={"primary"}
                onClick={this.toggleBookingDrawer}
              >
                <Icon style={{color: "#fff"}}>assignment</Icon>
              </Fab>
            )}
          </Grid>
        </div>
        {chef && chef.dishesList && chef.dishesList.dishes && chef.dishesList.dishes.length && (
          <>
            {chef.dishesList.dishes.map(d => (
              <a key={d.id} href={`https://cuisinecrafters.net/dish/${d.slug}`} target="_blank" style={{ display: 'none' }}></a>
            ))}
          </>
        )}

        {chef && chef.postsList && chef.postsList.posts && chef.postsList.posts.length && (
          <>
            {chef.postsList.posts.map(d => (
              <a key={d.id} href={`https://cuisinecrafters.net/post/${d.postSlug}`} target="_blank" style={{ display: 'none' }}></a>
            ))}
          </>
        )}
      </div>
    );
  }

}

/*const ChefDinerWithData = compose(
  graphql(GET_SAVED_CHEFS, {
    name: "savedChefs",
    options: props => ({
      variables: {
        userId: props.userId
      }
    })
  })
)(ChefDiner);*/

const mapStateToProps = state => {
  return {
    chef: state.chefs.chef,
    loading: state.chefs.chefLoading,
  };
};

const ChefDetailsDiner = connect(mapStateToProps)(ChefDiner);
export default ChefDetailsDiner;

const styles = {
  chefImgIPad: {
    width: 150,
    height: 150
  },
  chefImgLg: {
    width: 212,
    height: 212

  },
  reviewImgLg: {
    width: 73,
    height: 73
  },
  reviewImgIpad: {
    width: 100,
    height: 100
  },
  chefImg: {
    borderRadius: "50%",
    borderWidth: 4,
    borderStyle: "solid",
    borderColor: primaryColor,
    float: "right",
    outline: "none"
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    weight: 500
  },
  chefCuisine: {
    fontFamily: webFont,
    color: textGrey,
    fontSize: 15,
    weight: 500,
    maxWidth: 400
  },
  createButton: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    minWidth: 220,
    color: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontSize: 20,
  },
  dishName: {
    fontFamily: webFont,
    color: textBlack,
    fontSize: 20,
    weight: 500,
    maxWidth: 400
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10
  },
  ftGrid: {
    marginTop: 25,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    marginBottom: 10,
    marginTop: 20,
    fontSize: 30,
    textAlign: 'center'
  },
  setFont: {
    fontFamily: webFont
  },
  rateContent: {
    width: 48,
    height: 21,
    fontSize: 15
  },
  starRating: {
    width: 18,
    height: 18,
    fontSize: 18
  },
  setFontGrey: {
    color: "#7c7c7c"
  },
  setFontPrimary: {
    color: primaryColor
  },
  showBtn: {
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20
  },
  bookingFab: {
    position: "fixed",
    bottom: 40,
    right: 40
  },
  tick: {
    width: 28,
    height: 28,
  }
};
